var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-container"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab,staticClass:"tab-btn",class:{ active: _vm.currentTab === tab },on:{"click":function($event){return _vm.$emit('change-tab', tab)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }